declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';



import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePaymentModeInfoRequest, DoctorsListController, DoctorsListRequest, ServiceProvidersController, GetServiceProvidersRequest, GenericProcPostRequest, S_Methods, AdmissionServicesController } from '../../../models/actor/actor';
import { ServiceConsultantMapRequest, AdmissionServiceDetail } from '../../../models/actor/actor';
import { ActorService } from '../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../models/master/mastermodel';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbOPSearchProviderModal } from '../follow up/counsellingregistry/modal/opsearchprovider.modal';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';

@Component({
  selector: 'ngbaoeditservice',
  templateUrl: './aoeditservice.modal.html',
  styleUrls: ['./aoeditservice.modal.scss']
})

export class NgbAOEditServiceModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() AdmissionService: AdmissionServiceDetail;
  @Input() CurrentAdmissionServicesController: AdmissionServicesController;
  //@Input() AdmissionNo: string;
  //@Input() AdmissionDate: Date;
  //@Input() CareUnit: string;
  //@Input() BedLocation: string;
  //@Input() PatientName: string;
  //@Input() TreatmentCategory: string;
  //@Input() PatientFormattedCode: string;
  //@Input() ServiceName: string;
  TodayDate = new Date();
  public UpdatedServiceDate: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  public UpdatedProviderName: string;
  public UpdatedProviderCost: number;
  public isRequesting: boolean = false;


  constructor(public activeModal: NgbActiveModal,
    private loaderService: SpinnerService,
    private modalService: NgbModal, private actorservice: ActorService,
    private router: Router, private route: ActivatedRoute,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.LoadDoctorsList();
    //alert(this.AdmissionService.ServiceDate.toDateString());
    this.UpdatedProviderName = this.AdmissionService.ProviderName;
    this.UpdatedProviderCost = this.AdmissionService.ProviderCost;
    this.GetServiceProviders();
    this.UpdatedServiceDate = {
      year: this.AdmissionService.ServiceDate.getUTCFullYear(),
      month: this.AdmissionService.ServiceDate.getUTCMonth() + 1 ,
      day: this.AdmissionService.ServiceDate.getDate()
    };
    //alert(this.UpdatedServiceDate.day.toString() + " / "+ this.UpdatedServiceDate.month.toString() );
  }

  public ProviderName: string;
  public ProviderCode: number;
  public ProviderNumber: number;

  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  close_dialog(a: AdmissionServiceDetail) {
    //alert(this.UpdatedServiceDate.day.toString() + " / " + this.UpdatedServiceDate.month.toString());
    a.ServiceDate = new Date(this.parserFormatter.format(this.UpdatedServiceDate));
    //alert(a.ServiceDate.toDateString());
    //this.;
    this.activeModal.close(a);
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentServiceProvidersController: ServiceProvidersController[];
  GetServiceProviders() {
    var getReq = new GetServiceProvidersRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 201020;
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    //alert(this.CurrentBillDetails.ItemCode);
    getReq.ServiceCode = this.AdmissionService.ServiceCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 201020;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentServiceProvidersController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onChange(Event: any) {
    if (Event != null && this.CurrentDoctorsListController.length > 0) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      if (a.length > 0) {
        if (
          this.CurrentServiceProvidersController != null &&
          this.CurrentServiceProvidersController.length > 0) {
          if (this.CurrentServiceProvidersController
            .filter(x => x.PrCode == Event.value).length > 0
          ) {

            this.AdmissionService.ProviderName = this.CurrentServiceProvidersController
              .filter(x => x.PrCode == Event.value)[0].ProviderName;

            this.AdmissionService.ProviderCode =
              this.CurrentServiceProvidersController
                .filter(x => x.PrCode == Event.value)[0].ProviderCode;

            this.AdmissionService.ProviderCost =
              this.CurrentServiceProvidersController
                .filter(x => x.PrCode == Event.value)[0].ProviderCost;
          }
          else {
            this.AdmissionService.ProviderCode = this.CurrentAdmissionServicesController.ProviderCode;
            this.AdmissionService.ProviderCost = this.CurrentAdmissionServicesController.UnitPrice;
            this.AdmissionService.ProviderName = this.CurrentAdmissionServicesController.ProviderName;
          }
        } else {
          this.AdmissionService.ProviderCode = a[0].ProviderCode;
          this.AdmissionService.ProviderCost = this.CurrentAdmissionServicesController.UnitPrice;
          this.AdmissionService.ProviderName = a[0].DisplayName;
        }
      }
    }
    else {

    }
  }
  //onChange(Event: any) {
  //  if (Event != null && this.CurrentDoctorsListController.length > 0) {
  //    var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
  //    if (a.length > 0) {
  //      this.AdmissionService.ProviderName = a[0].DisplayName;
  //      this.AdmissionService.ProviderCode = a[0].ProviderCode;
  //    }
  //  }

  //}
  ServiceProvider() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.IsShowDoctor = true;
    modalRef.componentInstance.DoctorType = 'DOC';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName = receivedEntry.make;
      this.ProviderCode = receivedEntry.value;
      this.ProviderNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}
